import React from "react";
import SvgIcon from '@material-ui/core/SvgIcon';
import { makeStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';

export const CommandIcon = ({ onClick, title = "Commands" }) => {
    const classes = useStyles();

    const handleClick = event => {
        if (onClick) {
            event.stopPropagation();
            onClick();
        }
    };

    return (
        <Tooltip disableFocusListener disableTouchListener title={title}>
            <SvgIcon viewBox="0 0 31.586 31.586" className={classes.icon} onClick={handleClick}>
                <path d="M29.328,2.255H2.256C1.01,2.255,0,3.264,0,4.51v22.564c0,1.245,1.01,2.256,2.256,2.256h27.072
              c1.244,0,2.258-1.012,2.258-2.256V4.51C31.586,3.264,30.572,2.255,29.328,2.255z M7.333,3.949c0.622,0,1.128,0.502,1.128,1.128
              c0,0.623-0.506,1.125-1.128,1.125c-0.626,0-1.131-0.502-1.131-1.125C6.202,4.451,6.707,3.949,7.333,3.949z M3.947,3.949
              c0.623,0,1.127,0.502,1.127,1.128c0,0.623-0.504,1.125-1.127,1.125c-0.624,0-1.129-0.502-1.129-1.125
              C2.818,4.451,3.323,3.949,3.947,3.949z M29.328,27.075H2.256V7.92h27.072C29.328,7.92,29.328,27.075,29.328,27.075z" />
                <polygon points="12.645,12.556 5.4,9.243 5.4,10.84 11.003,13.235 11.003,13.266 5.4,15.66 5.4,17.256 12.645,13.943 	" />
            </SvgIcon>
        </Tooltip>
    );
}

const useStyles = makeStyles(theme => ({
    icon: {
        color: theme.palette.primary.light,
        cursor: "pointer",
        padding: theme.spacing(0.5)
    }
}))
